{
  "alert.informative": "Asiapitoinen",
  "alert.negative": "Kielteinen",
  "alert.notice": "Ilmoitus",
  "alert.positive": "Myönteinen",
  "attachmentlist.nextAttachments": "Näytä seuraavat liitteet",
  "attachmentlist.previousAttachments": "Näytä edelliset liitteet",
  "chat.newMessage": "Uusi viesti",
  "chat.scrollToBottom": "Vieritä alas",
  "messagefeedback.thumbDown": "Huono vastaus",
  "messagefeedback.thumbUp": "Hyvä vastaus",
  "promptfield.aiDisclaimer": "Vastaukset on luotu tekoälyä käyttäen, ja ne voivat olla epätarkkoja. Tarkista ennen kuin käytät niitä.",
  "promptfield.aiUserGuidlines": "Tekoälyn käyttäjän ohjeet",
  "promptfield.attachments": "Liitteet",
  "promptfield.insertButton": "Lisää",
  "promptfield.label": "Kehote",
  "promptfield.placeholder": "Oletko valmis aloittamaan? Esitä kysymys, jaa idea tai lisää tehtävä.",
  "promptfield.placeholder.small": "Kysy mitä tahansa",
  "promptfield.stopButton": "Pysäytä",
  "promptfield.submitButton": "Lähetä",
  "promptfield.uploading": "Ladataan",
  "responsestatus.loading": "Ladataan",
  "responsestatus.processing": "Käsitellään...",
  "voicebutton.startListening": "Aloita äänitys",
  "voicebutton.stopListening": "Pysäytä äänitys"
}
